import React from "react";
import { FileText, Folder, ShieldCheck } from "lucide-react";

const resources = [
  { value: "Application", icon: FileText, description: "Application access" },
  { value: "Folder", icon: Folder, description: "Folder access" },
  { value: "Privilege", icon: ShieldCheck, description: "Group membership" },
];

const ResourceTypeSelection = ({
  activeResourceType,
  setActiveResourceType,
}) => (
  <div className="op-choice-grid">
    {resources.map((resource) => {
      const selected = activeResourceType.includes(resource.value);
      return (
        <label
          key={resource.value}
          className={`op-choice ${selected ? "is-selected" : ""}`}
        >
          <input
            type="checkbox"
            checked={selected}
            onChange={() =>
              setActiveResourceType((previous) =>
                selected
                  ? previous.filter((item) => item !== resource.value)
                  : [...previous, resource.value],
              )
            }
          />
          <resource.icon aria-hidden="true" />
          <span>
            <strong>{resource.value}</strong>
            <small>{resource.description}</small>
          </span>
        </label>
      );
    })}
  </div>
);

export default ResourceTypeSelection;
